import { Megaphone, X } from "lucide-react";
import { Button } from "../../../components/ui/button";
import PublishButton from "../PublishButton";

const PublishReminder = ({ onClose, isNeedPublish, setConfirmModal, confirmPublish, setActiveTab, setShouldLoadQna }: any) => (
  <div
    data-evo-island
    role="status"
    aria-labelledby="publish-reminder-title"
    className="fixed right-5 top-5 z-[2000] max-sm:bottom-5 max-sm:top-auto w-[min(20rem,calc(100vw-2.5rem))] rounded-xl border border-border bg-card p-4 text-card-foreground shadow-lg"
  >
    <div className="flex items-start gap-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Megaphone className="size-4" aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p id="publish-reminder-title" className="m-0 text-sm font-semibold text-foreground">
          Changes saved
        </p>
        <p className="m-0 mt-0.5 text-sm text-muted-foreground">Your changes are ready to publish.</p>
      </div>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="-mr-2 -mt-2 size-8 text-muted-foreground"
        aria-label="Close"
        onClick={onClose}
      >
        <X aria-hidden="true" />
      </Button>
    </div>
    <div className="mt-3 flex items-center justify-end gap-2">
      <Button type="button" variant="outline" size="sm" onClick={onClose}>
        Later
      </Button>
      <PublishButton
        isNeedPublish={isNeedPublish}
        setConfirmModal={setConfirmModal}
        confirmPublish={confirmPublish}
        setActiveTab={setActiveTab}
        setShouldLoadQna={setShouldLoadQna}
        showIndicator={false}
        size="sm"
        className="w-auto"
      />
    </div>
  </div>
);

export default PublishReminder;
